<template>
    <div>
        <label
            v-if="labelClickable" 
            class="gz-input-container__label gz-input-container__label_clickable" 
            :class="{ 'gz-input-container__label_required': required }"
            @click="$emit('labelClick')"
        >{{ label }}</label>
        <label 
            v-else
            class="gz-input-container__label" 
            :class="{ 'gz-input-container__label_required': required }"
        >{{ label }}</label>

        <div v-if="note" class="gz-input-container__label__note">
            <p v-html="note"></p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Label',

    props: {
        label: String,
        labelClickable: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        note: String
    }
}
</script>